import type { WireInt } from '../../services/roomInspectorApi';
import { messageTime } from './messageMetadata';

export function MessageTime({ value }: { value?: WireInt }) {
  const time = messageTime(value);
  return time ? (
    <time className="inspector-message-time" dateTime={time.iso}>
      {time.label}
    </time>
  ) : null;
}
